// Get wallet balance
export const GET_WALLET_BALANCE_REQUEST = 'GET_WALLET_BALANCE_REQUEST'
export const GET_WALLET_BALANCE_SUCCESS = 'GET_WALLET_BALANCE_SUCCESS'
export const GET_WALLET_BALANCE_FAIL = 'GET_WALLET_BALANCE_FAIL'
export const GET_WALLET_BALANCE_RESET = 'GET_WALLET_BALANCE_RESET'

// Get user transactions
export const GET_USER_TRANSACTIONS_REQUEST = 'GET_USER_TRANSACTIONS_REQUEST'
export const GET_USER_TRANSACTIONS_SUCCESS = 'GET_USER_TRANSACTIONS_SUCCESS'
export const GET_USER_TRANSACTIONS_FAIL = 'GET_USER_TRANSACTIONS_FAIL'
export const GET_USER_TRANSACTIONS_RESET = 'GET_USER_TRANSACTIONS_RESET'

// Create deposit
export const CREATE_DEPOSIT_REQUEST = 'CREATE_DEPOSIT_REQUEST'
export const CREATE_DEPOSIT_SUCCESS = 'CREATE_DEPOSIT_SUCCESS'
export const CREATE_DEPOSIT_FAIL = 'CREATE_DEPOSIT_FAIL'
export const CREATE_DEPOSIT_RESET = 'CREATE_DEPOSIT_RESET'

// Create withdraw
export const CREATE_WITHDRAW_REQUEST = 'CREATE_WITHDRAW_REQUEST'
export const CREATE_WITHDRAW_SUCCESS = 'CREATE_WITHDRAW_SUCCESS'
export const CREATE_WITHDRAW_FAIL = 'CREATE_WITHDRAW_FAIL'
export const CREATE_WITHDRAW_RESET = 'CREATE_WITHDRAW_RESET'

// Create buy-in
export const CREATE_BUYIN_REQUEST = 'CREATE_BUYIN_REQUEST'
export const CREATE_BUYIN_SUCCESS = 'CREATE_BUYIN_SUCCESS'
export const CREATE_BUYIN_FAIL = 'CREATE_BUYIN_FAIL'
export const CREATE_BUYIN_RESET = 'CREATE_BUYIN_RESET'

// Create cashout
export const CREATE_CASHOUT_REQUEST = 'CREATE_CASHOUT_REQUEST'
export const CREATE_CASHOUT_SUCCESS = 'CREATE_CASHOUT_SUCCESS'
export const CREATE_CASHOUT_FAIL = 'CREATE_CASHOUT_FAIL'
export const CREATE_CASHOUT_RESET = 'CREATE_CASHOUT_RESET'

// Get all transactions (Admin)
export const GET_ALL_TRANSACTIONS_REQUEST = 'GET_ALL_TRANSACTIONS_REQUEST'
export const GET_ALL_TRANSACTIONS_SUCCESS = 'GET_ALL_TRANSACTIONS_SUCCESS'
export const GET_ALL_TRANSACTIONS_FAIL = 'GET_ALL_TRANSACTIONS_FAIL'
export const GET_ALL_TRANSACTIONS_RESET = 'GET_ALL_TRANSACTIONS_RESET'

// Update transaction status (Admin)
export const UPDATE_TRANSACTION_STATUS_REQUEST = 'UPDATE_TRANSACTION_STATUS_REQUEST'
export const UPDATE_TRANSACTION_STATUS_SUCCESS = 'UPDATE_TRANSACTION_STATUS_SUCCESS'
export const UPDATE_TRANSACTION_STATUS_FAIL = 'UPDATE_TRANSACTION_STATUS_FAIL'
export const UPDATE_TRANSACTION_STATUS_RESET = 'UPDATE_TRANSACTION_STATUS_RESET'


// NEW CONSTANTS FOR ADMIN TRANSACTIONS
// Create admin transaction
export const CREATE_ADMIN_TRANSACTION_REQUEST = 'CREATE_ADMIN_TRANSACTION_REQUEST'
export const CREATE_ADMIN_TRANSACTION_SUCCESS = 'CREATE_ADMIN_TRANSACTION_SUCCESS'
export const CREATE_ADMIN_TRANSACTION_FAIL = 'CREATE_ADMIN_TRANSACTION_FAIL'
export const CREATE_ADMIN_TRANSACTION_RESET = 'CREATE_ADMIN_TRANSACTION_RESET'

// Get users for transaction
export const GET_USERS_FOR_TRANSACTION_REQUEST = 'GET_USERS_FOR_TRANSACTION_REQUEST'
export const GET_USERS_FOR_TRANSACTION_SUCCESS = 'GET_USERS_FOR_TRANSACTION_SUCCESS'
export const GET_USERS_FOR_TRANSACTION_FAIL = 'GET_USERS_FOR_TRANSACTION_FAIL'
export const GET_USERS_FOR_TRANSACTION_RESET = 'GET_USERS_FOR_TRANSACTION_RESET'



export const CREATE_CHIP_DEPOSIT_REQUEST = 'CREATE_CHIP_DEPOSIT_REQUEST'
export const CREATE_CHIP_DEPOSIT_SUCCESS = 'CREATE_CHIP_DEPOSIT_SUCCESS'
export const CREATE_CHIP_DEPOSIT_FAIL = 'CREATE_CHIP_DEPOSIT_FAIL'
export const CREATE_CHIP_DEPOSIT_RESET = 'CREATE_CHIP_DEPOSIT_RESET'

// Download transaction receipt
export const DOWNLOAD_RECEIPT_REQUEST = 'DOWNLOAD_RECEIPT_REQUEST'
export const DOWNLOAD_RECEIPT_SUCCESS = 'DOWNLOAD_RECEIPT_SUCCESS'
export const DOWNLOAD_RECEIPT_FAIL = 'DOWNLOAD_RECEIPT_FAIL'


// Get Club Ledger (Admin)
export const GET_CLUB_LEDGER_REQUEST = 'GET_CLUB_LEDGER_REQUEST'
export const GET_CLUB_LEDGER_SUCCESS = 'GET_CLUB_LEDGER_SUCCESS'
export const GET_CLUB_LEDGER_FAIL = 'GET_CLUB_LEDGER_FAIL'
export const GET_CLUB_LEDGER_RESET = 'GET_CLUB_LEDGER_RESET'
